import { render, staticRenderFns } from "./RegisteredCaptains.vue?vue&type=template&id=23b3aada&scoped=true"
import script from "./RegisteredCaptains.vue?vue&type=script&lang=js"
export * from "./RegisteredCaptains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3aada",
  null
  
)

export default component.exports